module.exports = __webpack_public_path__ + "img/logo1 (15).63f60777.jpg";